var React = require('react');

function FunnelIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M91.857 177.432a10.286 10.286 0 0 1-10.286-10.286v-44.485L25 50.661v-1.8a9.103 9.103 0 0 1 10.286-10.286h123.432c6.84 0 10.286 1.594 10.286 10.286v1.8l-56.571 72v36.772c0 3.237-1.525 6.286-4.115 8.229l-10.285 7.714a10.287 10.287 0 0 1-6.172 2.057l-.003-.001ZM36.674 48.864l55.183 70.2v48.085l10.286-7.714-.001-40.372 55.183-70.2-120.651.001Z","key":0}),React.createElement("path",{"d":"M127.857 69.428 97 110.572 66.143 69.428h61.714Z","key":1})]);
}

FunnelIconInline.defaultProps = {"className":"fill-current","viewBox":"0 0 200 178"};

module.exports = FunnelIconInline;

FunnelIconInline.default = FunnelIconInline;
